const _basePath = process.env.REACT_APP_DYNAMIC_IMAGE_PATH;

const imageHelper = {
  getImagePath: function (filename: string, maxWidth: number) {
    return `${_basePath}${filename}?width=${maxWidth}`;
  },
};

export default imageHelper;
